import { z, zCalendarDate } from '@harvestiq/zod';
import { AipIds } from '@harvestiq/constants';
import { submitAgWorksLrpEndorsementMsgSchema } from './submit-agworks-lrp-endorsement-msg';
import { createAgWorksLrpEndorsementResponseSchema } from '@harvestiq/external-clients-agworks-common';

export const submitAgWorksLrpEndorsementPdfMsgSchema = z.object({
  // iiq
  orgId: z.string(),
  aipId: z.nativeEnum(AipIds),
  endorsementId: z.string().uuid(),

  // pdf data
  pdfUrl: z.string().url(),
  insuredSignatureDate: zCalendarDate(),
  agentSignatureDate: zCalendarDate(),
  premiumLineOID: z.number(),

  // submitted endorsement metadata
  endorsementMessage: submitAgWorksLrpEndorsementMsgSchema,
  aipEndorsementResponse: createAgWorksLrpEndorsementResponseSchema,
});

export type SubmitAgWorksLrpEndorsementPdfMsg = z.infer<
  typeof submitAgWorksLrpEndorsementPdfMsgSchema
>;
